import React, { createContext, useContext, useMemo, useCallback } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'

import { loginApiKey, loginAD, logout as logoutAction, checkLogin as checkLoginAction } from '../../redux/actions/auth'

const defaultAuthValue = {
  user: null,
  loggingIn: false,
  loggedIn: false,
  error: null,
  loginWithApiKey: () => undefined,
  loginWithProvider: () => undefined,
  logout: () => undefined,
  checkLogin: () => undefined,
}

const AuthContext = createContext(defaultAuthValue)

export function AuthProvider({ children }) {
  const dispatch = useDispatch()
  const authState = useSelector((state) => state.auth)

  const loginWithApiKey = useCallback((secret) => dispatch(loginApiKey(secret)), [dispatch])
  const loginWithProvider = useCallback(() => dispatch(loginAD()), [dispatch])
  const logout = useCallback(() => dispatch(logoutAction()), [dispatch])
  const checkLogin = useCallback(() => dispatch(checkLoginAction()), [dispatch])

  const value = useMemo(() => ({
    user: authState.user,
    loggingIn: authState.loggingIn,
    loggedIn: authState.loggedIn,
    error: authState.error,
    loginWithApiKey,
    loginWithProvider,
    logout,
    checkLogin,
  }), [authState, loginWithApiKey, loginWithProvider, logout, checkLogin])

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  )
}

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
}

export function useAuth() {
  return useContext(AuthContext)
}
